//import action types
import * as types from "../actions/types"

const initialState = {
  data: [],
  error: []
};

const initialSearchReducer = (variable = initialState, action) => {
    const { type, payload } = action
    switch(action.type) {
        case types.nameSearch:
        case types.locationSearch:
        case types.emailSearch:
        case types.skillsSearch:
        case types.gaperIdSearch:
          const profiles = action.payload.map(d => ({...d, checked:false}))
          return{
            ...variable,
            data: profiles
          }
        default:
            return variable
    }
}

export default initialSearchReducer